<template>
  <div>
    <v-skeleton-loader
      type="table-thead, table-tbody"
      width="100%"
      :loading="stopLimitOrdersTableLoader"
      class="pa-4"
      boilerplate
    >
      <v-container class="prices-list-table pa-0 fill-height" fluid>
        <v-card width="100%" class="fill-height" color="gray10 pa-5">
          <v-row class="fill-height">
            <v-col cols="12">
              <v-row no-gutters align="center">
                <v-col cols="12">
                  <v-btn
                    color="primary"
                    class="white--text float-left"
                    @click="drawer = true"
                  >
                    {{ $t("stopLimitOrders.filter") }}
                    <v-icon right dark>
                      mdi-filter
                    </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <!--Table-->
              <StopLimitOrderTable
                :pairCoinScales="pairCoinScales"
                @cancelCreatedOrder="cancelCreatedOrder"
                :dataTable="orders"
              />
              <v-col class="py-0 my-3" cols="12">
                <v-row justify="center">
                  <v-col class="py-0 text-center" cols="12">
                    <v-pagination
                      class="custom-number-pagination"
                      v-model="pageNo"
                      total-visible="6"
                      :length="totalPage"
                      @input="loadDataPage"
                    ></v-pagination>
                  </v-col>
                </v-row>
              </v-col>
            </v-col>
          </v-row>
        </v-card>
      </v-container>
    </v-skeleton-loader>
    <v-navigation-drawer
      v-model="drawer"
      absolute
      temporary
      width="500px"
      class="pa-5 gray9"
    >
      <!-- <v-text-field
        v-model="formItem.date"
        :placeholder="$t('stopLimitOrders.trxRangeTime')"
        name="fromDate"
        type="text"
        outlined
        hide-details
        id="transaction-time"
        background-color="var(--v-field-base)"
        clearable
        clear-icon="$closeIcon"
      /> -->
      <date-picker
        v-model="formItem.date"
        format="YYYY-DD-MM"
        :display-format="!userInfo.is_global ? 'jYYYY-jMM-jDD' : 'YYYY-DD-MM'"
        :locale="userInfo.is_global ? 'en' : 'fa'"
        :popover="$vuetify.rtl ? 'bottom-right' : 'bottom-left'"
        color="#500fe9"
        clearable
        range
      />
      <v-autocomplete
        v-model="formItem.symbol"
        :items="symbol"
        item-text="symbol"
        item-value="symbol"
        filled
        :placeholder="$t('stopLimitOrders.pairCoin')"
        :menu-props="{ bottom: true, offsetY: true }"
        class="mt-8"
        outlined
        :no-data-text="$t('common.nodata')"
      ></v-autocomplete>
      <v-select
        :items="orderTypes"
        :placeholder="$t('stopLimitOrders.orderType')"
        outlined
        item-text="text"
        item-value="value"
        :menu-props="{ bottom: true, offsetY: true }"
        v-model="formItem.source"
      ></v-select>
      <v-select
        :items="directions"
        :placeholder="$t('stopLimitOrders.direction')"
        item-text="text"
        item-value="value"
        outlined
        :menu-props="{ bottom: true, offsetY: true }"
        v-model="formItem.direction"
      ></v-select>
      <v-row>
        <v-col>
          <v-btn block text color="primary" @click="handleSubmit">
            {{ $t("stopLimitOrders.search") }}
          </v-btn>
        </v-col>
        <v-col>
          <v-btn block color="error" text @click="handleClear">
            {{ $t("stopLimitOrders.clearFilters") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-navigation-drawer>
  </div>
</template>

<script>
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import StopLimitOrderTable from "@/components/Market/stopLimitOrders/StopLimitOrderTable.vue";
import { ExchangeService, MarketMarketService } from "@/services";
import dayjs from "dayjs";
import * as types from "@/store/types";
import { mapGetters } from "vuex";
export default {
  components: { datePicker: VuePersianDatetimePicker, StopLimitOrderTable },
  data() {
    return {
      drawer: false,
      loading: false,
      transactionTime: "",
      symbol: [],
      coinScales: {},
      orders: [],
      orderTypes: [
        {
          value: "STOP_LIMIT_CONDITION",
          text: this.$t("stopLimitOrders.stopLimit")
        },
        {
          value: "OCO_CONDITION",
          text: this.$t("stopLimitOrders.oco")
        }
      ],
      directions: [
        {
          text: this.$t("stopLimitOrders.buy"),
          value: 0
        },
        {
          text: this.$t("stopLimitOrders.sell"),
          value: 1
        }
      ],
      formItem: {
        symbol: "",
        source: "",
        direction: "",
        date: ""
      },
      pairCoinScales: [],
      stopLimitOrdersTableLoader: false,
      pageSize: 10,
      pageNo: 1,
      total: 1,
      totalPage: 0
    };
  },
  computed: {
    ...mapGetters({
      userInfo: types.userInfo.getters.GET_USER_INFO
    })
  },
  created() {
    this.getAllPreconditionOrders();
    this.getPairCoinScales();
    this.getSymbol();
  },
  methods: {
    clearSelect(e, key) {
      e.stopPropagation();
      this.formItem[key] = "";
    },
    loadDataPage(data) {
      this.pageNo = data;
      this.getAllPreconditionOrders();
    },
    getAllPreconditionOrders() {
      this.loading = true;
      const { symbol, direction, source, date: rangeDate } = this.formItem;

      let startTime, endTime;

      if (rangeDate) {
        startTime = dayjs(rangeDate[0], "YYYY-DD-MM").valueOf();
        endTime = rangeDate[1]
          ? dayjs(rangeDate[1], "YYYY-DD-MM").valueOf()
          : null;
      }

      let payload = {
        symbol: symbol,
        direction: direction,
        startTime: startTime,
        endTime: endTime,
        source: source,
        pageNo: this.pageNo,
        pageSize: this.pageSize
      };
      Object.keys(payload).forEach(key => {
        if (payload[key] === "" || payload[key] === undefined) {
          delete payload[key];
        }
      });
      this.orders = [];
      ExchangeService.getAllActivePreconditionsByFilterService(payload)
        .then(response => {
          let preconditionOrdersList = response.data.data.content;
          let rows = [];
          if (preconditionOrdersList.length > 0) {
            this.total = response.data.data.totalElements;
            this.totalPage = Math.ceil(
              response.data.data.totalElements / this.pageSize
            );
            for (let i = 0; i < preconditionOrdersList.length; i++) {
              let row = preconditionOrdersList[i];
              row.price =
                row.type === "MARKET_PRICE"
                  ? this.$t("stopLimitOrders.marketPrice")
                  : row.price;
              rows.push(row);
            }
            this.orders = rows;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getPairCoinScales() {
      MarketMarketService.getPairCoinScales().then(res => {
        this.pairCoinScales = res.data.data;
      });
    },
    handleSubmit() {
      this.pageNo = 1;
      this.getAllPreconditionOrders();
      this.value = false;
    },
    handleClear() {
      this.formItem = {
        symbol: "",
        source: "",
        direction: "",
        date: ""
      };
      this.handleSubmit();
    },
    getSymbol() {
      MarketMarketService.getSymbolsThumb().then(response => {
        if (response.data.length > 0) {
          this.symbol = response.data;
        }
      });
    },
    cancelCreatedOrder(orderId) {
      ExchangeService.cancelPreconditionOrderService(orderId)
        .then(() => {
          this.getAllPreconditionOrders();
          this.$toast.success(this.$t("stopLimitOrders.successCancel"));
        })
        .catch(err => {
          this.$toast.error(err.message);
        });
    },
    convertToTimeStamp(time) {
      const miladiDate = dayjs(time, { jalali: true });
      if (miladiDate.isValid()) {
        return miladiDate.valueOf();
      }
      return null;
    }
  }
};
</script>

<style lang="scss" scoped></style>
